import { Link } from "react-router";
import { useApi } from "../api";
import type { PortalConfig } from "../config";

interface Planned { kind: string; ticketNo: number; customer: string; email: string; phone: string; number: number }

const LABEL: Record<string, string> = {
  "estimate-first": "Estimate follow-up (2 days after the estimate)",
  "estimate-reminder": "Estimate reminder (every 2 days)",
  "invoice-reminder": "Invoice reminder (every 2 days)",
  "label-text": "Label text (3 days after the ticket, still at Label Sent)",
  review: "Review request (14 days after Resolved, once per customer)",
};

/**
 * Automatic follow-ups (owner, 2026-11-03): what the daily job would send today. It starts switched off; once
 * this list looks right, it is turned on in the code (JOBS_ENABLED in infra/lib/foundation-stack.ts).
 */
export function FollowUpsPage({ config }: { config: PortalConfig }) {
  const { data, error, loading } = useApi<{ jobs: Planned[]; enabled: boolean }>(config, "/jobs/preview");
  const groups = Object.keys(LABEL).map((k) => ({ k, rows: data?.jobs.filter((j) => j.kind === k) ?? [] }));
  return (
    <div className="followups">
      <h2>Automatic follow-ups</h2>
      <p className="muted">
        {data?.enabled ? "Switched on: these go out at about 10 AM Central." : "Switched off. This is what the daily job would send if it ran today; nothing is sent."}
        {" "}Tickets with Silence Reminders, an unread customer message, or a wholesale customer with email off are left out.
      </p>
      {error && <p className="error">{error.message}</p>}
      {loading && <p className="muted">Loading…</p>}
      {data && groups.map((g) => (
        <section key={g.k}>
          <h3>{LABEL[g.k]} · {g.rows.length}</h3>
          {g.rows.length ? (
            <table className="t-plain">
              <thead><tr><th>Ticket</th><th>Customer</th><th>Email</th><th>Phone</th><th>#</th></tr></thead>
              <tbody>{g.rows.map((r) => (
                <tr key={`${r.kind}-${r.ticketNo}`}><td><Link to={`/tickets/${r.ticketNo}`}>#{r.ticketNo}</Link></td><td>{r.customer}</td><td>{r.email}</td><td>{r.phone}</td><td>{r.number}</td></tr>
              ))}</tbody>
            </table>
          ) : <p className="muted">None today.</p>}
        </section>
      ))}
    </div>
  );
}
